<template>
  <div>
    <product-page-wrapper type="ringkasan-materi" />
  </div>
</template>

<script>
import ProductPageWrapper from "@/components/products/ProductPageWrapper.vue";

export default {
  components: {
    ProductPageWrapper,
  },
};
</script>
